import { render, staticRenderFns } from "./AssetGroupDetails.vue?vue&type=template&id=11ba7cf7&scoped=true&"
import script from "./AssetGroupDetails.vue?vue&type=script&lang=js&"
export * from "./AssetGroupDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssetGroupDetails.vue?vue&type=style&index=0&id=11ba7cf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba7cf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ba7cf7')) {
      api.createRecord('11ba7cf7', component.options)
    } else {
      api.reload('11ba7cf7', component.options)
    }
    module.hot.accept("./AssetGroupDetails.vue?vue&type=template&id=11ba7cf7&scoped=true&", function () {
      api.rerender('11ba7cf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AssetTracking/AssetGroupDetails.vue"
export default component.exports